import React, { useEffect, useRef, useState } from 'react';
import { Fab, Tooltip } from '@mui/material';
import { URL_PARAM_INIT } from '../../../var';
import { getUrlHasParam } from '../../lib/utils';
import ShareIcon from '@mui/icons-material/Share';
import l10n from '../../lib/l10n';

function ShareTool() {
  const [copied, setCopied] = useState(false);
  const timeoutID = useRef();

  useEffect(() => () => clearTimeout(timeoutID.current), []);
  const onClick = (e) => {
    let currentUrl = window.location.href;
    if (!getUrlHasParam(URL_PARAM_INIT)) {
      currentUrl += '&' + URL_PARAM_INIT + '=1';
    }
    const sanitizedUrl = encodeURI(decodeURI(currentUrl));
    navigator.clipboard.writeText(sanitizedUrl).then(() => {
      setCopied(true);
      timeoutID.current = setTimeout(() => setCopied(false), 5000);
    }).catch(err => {
      console.error('Errore nella copia negli appunti:', err);
    });
  };

  const tooltipProps = {
    placement: 'left',
    // ...(copied && ({
    //   open: true
    // }))
  };

  return (
    <Tooltip
      placement="top"
      title={copied 
        ? l10n.ui_button_share_on_text.toString() 
        : l10n.ui_button_share_off_text.toString()
      }>
      <Fab onClick={onClick}>
        <ShareIcon />
      </Fab>
    </Tooltip>
  );
};

export default ShareTool;